<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-12-08 10:29:01
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Claim\ClaimType\components\editApprovalFlow.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-09-16 11:19:49
-->
<template>
  <normalDialog
    width="700"
    @close="closeDialog"
    scrollable
    :title="
      iSEdited
        ? $t('label_essweb_ClaimType_form_dilog_editApprovalFlowTitle')
        : $t('label_essweb_ClaimType_form_dilog_viewApprovalFlowTitle')
    "
    :dialog="show"
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <normalInputTextFiled
              type="number"
              :filled="iSEdited"
              :readonly="!iSEdited"
              maxlength="10"
              :label="$t('label_essweb_ClaimType_form_dilog_claimAmountLabel')"
              v-model="approvalFlowData.amount"
              :rules="
                $GetRules(['_Number_negative', '_Length_Rules'], [null, 10])
              "
              :placeholder="
                $t('label_essweb_ClaimType_form_dilog_claimAmountLabel')
              "
            >
              <template v-slot:prepend-inner>
                <span class="mt-1">≥</span>
              </template></normalInputTextFiled
            >
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t("label_essweb_ClaimType_form_dilog_approvalTemplateLabel")
            }}</v-sheet>
            <v-autocomplete
              :items="approvalTemplates"
              item-text="flow_template_name"
              item-value="uuid"
              :filled="iSEdited"
              :readonly="!iSEdited"
              v-model="approvalFlowData.approval_flow_template_uuid"
              :append-icon="iSEdited ? 'arrow_drop_down' : ''"
              single-line
              :rules="$GetRules(['_Require_Rules'], [null])"
              :placeholder="
                $t('label_essweb_ClaimType_form_dilog_approvalTemplateLabel')
              "
              dense
            >
              <template v-slot:no-data> <noContent /> </template
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:actions>
      <CardActions
        saveBtn
        cancelBtn
        @save="onSave"
        @cancel="closeDialog"
        v-if="iSEdited"
      />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "editApprovalFlow",
  props: ["iSEdited", "show", "curUuid"],
  computed: {
    ...mapGetters(["companyLang"]),
    approvalTemplates() {
      return this.$getSelectTrans(
        this.approvalTemplateData,
        "flow_template_name"
      );
    },
  },
  watch: {
    curUuid(val) {
      if (val) this.getDetil();
    },
    show(val) {
      if (!val) {
        this.approvalFlowData = {
          uuid: null,
          amount: 0,
          approval_flow_template_uuid: null,
          approval_flow_template_name: this.$getCommonLangKey(this.companyLang),
        };
      }
    },
    "approvalFlowData.approval_flow_template_uuid": function (val) {
      if (!val) {
        this.approvalFlowData.approval_flow_template_name =
          this.$getCommonLangKey(this.companyLang);
      } else {
        let obj = this.approvalTemplateData.find((ele) => ele.uuid === val);
        this.approvalFlowData.approval_flow_template_name =
          obj["flow_template_name"];
      }
    },
  },
  data() {
    return {
      approvalTemplateData: [],
      approvalFlowData: {
        uuid: null,
        amount: 0,
        approval_flow_template_uuid: null,
        approval_flow_template_name: "",
      },
    };
  },
  mounted() {
    this.approvalFlowData.approval_flow_template_name = this.$getCommonLangKey(
      this.companyLang
    );

    this.getApprovalTemplates();
  },
  methods: {
    closeDialog: function () {
      this.$emit("close");
    },
    getDetil: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_type_approval_condition",
        url: "/claim-type-approval-condition/get-details/",
        data: {
          uuid: this.curUuid,
        },
      }).then((res) => {
        that.approvalFlowData = res.data;
      });
    },
    getApprovalTemplates: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_templates",
        url: "/approval-template/get-approval-template-list/",
        data: {
          business_data_table_name: "ess_clm_claim_form_records", //bj 2021-07-05
        },
      }).then((res) => {
        that.approvalTemplateData = res.data;
      });
    },
    onSave: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$emit("onSave", this.approvalFlowData);
    },
  },
};
</script>